import{useState as t,useCallback as o}from"react";import r from"../utils/callActionAsync.js";const c=c=>{const[s,n]=t(!1);return[o(((...t)=>r(c,t,n)),[c]),s]};export{c as default};
//# sourceMappingURL=useAsyncAction.js.map
